import { t } from '../../../strings/i18n';
import { length, required } from '../../../xform';
export const CVV2_INPUT_NAME = 'cvv2';
const cvv2Config = () => [
    CVV2_INPUT_NAME,
    undefined,
    'ENABLED',
    [required(t('errors.cvvRequired')), length(t('errors.cvvInvalid'), 3)]
];
export default cvv2Config;
